<div class="listing-details" style="height: 715px">
  <p-carousel
    [value]="productImageList"
    styleClass="custom-carousel"
    [numVisible]="1"
    [numScroll]="1"
    [circular]="productImageList.length > 1"
    [showIndicators]="productImageList.length > 1"
    [autoplayInterval]="3000"
    [responsiveOptions]="responsiveOptionsBanner"
    class="islands-carousel listingDetailsBanner"
    [ngClass]="this.language"
  >
    <ng-template let-product pTemplate="item">
      <div class="product-item slider-arrow" style="height: 715px" (click)="imageClick(product)">
        <div class="product-item-content" style="height: 715px">
          <div class="image detailsBanner" style="height: 715px">
            <img [src]="product.serverPathWithCrop" class="product-image slider-image top-image" />
          </div>
          <div class="title" *ngIf="product.name && product.name !== ''">
            <h3>{{ product.name }}</h3>
          </div>
          <div class="copyright container cr-caption" *ngIf="product.copyright !== '' || product.caption !== ''">
            <i class="fas fa-camera-retro"></i>
            <small
              >{{ product.copyright | uppercase }}
              <span *ngIf="product.copyright !== '' && product.caption !== ''">/</span>
              {{ product.caption | uppercase }}
            </small>
          </div>
        </div>
      </div>
    </ng-template>
  </p-carousel>
</div>

<p-galleria
  [(value)]="productImageList"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [circular]="true"
  [fullScreen]="true"
  [showItemNavigators]="true"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item.plainPath" class="gallery-image" />
  </ng-template>
</p-galleria>

<div class="container searchResult">
  <app-breadcrumb-row></app-breadcrumb-row>
  <div class="row">
    <div class="col-md-12">
      <h1 class="mb-1 listingDetailsHeading">
        <b>{{ listingDetails.productName }}</b>
      </h1>
      <div class="format mt-3" [innerHtml]="listingDetails.productDescription"></div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="content-wrapper">
        <div class="category-container">
          <div class="category-list">
            <div
              *ngFor="let cat of categoryData; let i = index"
              class="category-item"
              [class.active]="i === activeTabIndex"
              (click)="activeTabIndex = i"
            >
              {{ cat.name | translate }}
            </div>
          </div>
          <div class="category-content" *ngIf="categoryData.length > 0">
            <div *ngFor="let cat of categoryData; let i = index" [hidden]="i !== activeTabIndex">
              <div class="p-grid accommodationGrid" *ngIf="i == 0">
                <div class="p-lg-12" style="padding: 15px !important">
                  <div class="p-grid" #productsList>
                    <ng-container *ngFor="let item of whereToStayData">
                      <div class="p-col-12 p-md-6 p-lg-3">
                        <p-card>
                          <ng-template pTemplate="header">
                            <div>
                              <a
                                target="_blank"
                                class="product-item alisting"
                                [href]="'/listingdetails/' + item.productId"
                              >
                                <img class="CategoriesImages" [src]="item.productImage"
                              /></a>
                              <div *ngIf="item.rateFrom" class="accomodationPrice">
                                <a
                                  target="_blank"
                                  class="product-item alisting"
                                  [href]="'/listingdetails/' + item.productId"
                                >
                                  <div class="price">
                                    <h3>{{ 'starting from' | translate }}</h3>
                                    SCR {{ item.rateFrom | number }}
                                    <!-- - SCR {{ item.rateTo }} -->
                                  </div>
                                </a>
                              </div>
                              <div *ngIf="item.productCategoryId === 'EVENT'; else eventWishlistHeart">
                                <span class="eventWishlistHeart" (click)="$event.stopPropagation()">
                                  <a (click)="addToWhishList(item)"
                                    ><i
                                      class="fa fa-heart wishlist"
                                      [style.color]="item.color ? item.color : '#fff'"
                                    ></i
                                  ></a>
                                </span>
                              </div>
                              <ng-template #eventWishlistHeart>
                                <span class="wishlistHeart" (click)="$event.stopPropagation()">
                                  <a (click)="addToWhishList(item)"
                                    ><i
                                      class="fa fa-heart wishlist"
                                      [style.color]="item.color ? item.color : '#fff'"
                                    ></i
                                  ></a>
                                </span>
                              </ng-template>
                            </div>
                            <div>
                              <ng-container *ngFor="let accr of item.accredations">
                                <span class="accBookMarkSpan">
                                  <img
                                    [src]="accr"
                                    class="accBookMarkSpanImg"
                                    [pTooltip]="isSustainableSeychelles(accr) ? sstlText(item, accr) : null"
                                    [escape]="false"
                                    tooltipPosition="bottom"
                                  />
                                </span>
                              </ng-container>
                            </div>
                          </ng-template>
                          <a target="_blank" class="product-item alisting" [href]="'/listingdetails/' + item.productId">
                            <div class="locationTitle">
                              <ng-container *ngFor="let classification of item.classification">
                                <div class="locationName list-comma" *ngIf="classification !== ''">
                                  <span [innerHTML]="classification"></span>
                                </div>
                              </ng-container>
                              <h5>{{ item.productName }}<i class="icon-safe"></i></h5>

                              <div class="locationName" *ngIf="item.island">
                                <i class="icon-location"></i>{{ item.addresses[0].islandArea
                                }}<span *ngIf="item.island && item.addresses[0].islandArea">,&nbsp;</span
                                >{{ item.island }}
                              </div>
                            </div>
                          </a>
                        </p-card>
                      </div>
                    </ng-container>
                  </div>
                  <div class="row mt-10">
                    <div class="col-md-12 text-center" *ngIf="isViewMoreRecords">
                      <a class="btn btn-primary btn-lg" (click)="ViewMoreRecord()"
                        >{{ 'View more' | translate }} <i class="glyphicon glyphicon-plus"></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="p-grid accommodationGrid" *ngIf="i == 1">
                <div class="p-lg-12" style="padding: 15px !important">
                  <div class="p-grid" #productsList>
                    <ng-container *ngFor="let item of placesToSeeData">
                      <div class="p-col-12 p-md-6 p-lg-3">
                        <p-card>
                          <ng-template pTemplate="header">
                            <div>
                              <a
                                target="_blank"
                                class="product-item alisting"
                                [href]="'/listingdetails/' + item.productId"
                              >
                                <img class="CategoriesImages" [src]="item.productImage"
                              /></a>
                              <div *ngIf="item.rateFrom" class="accomodationPrice">
                                <a
                                  target="_blank"
                                  class="product-item alisting"
                                  [href]="'/listingdetails/' + item.productId"
                                >
                                  <div class="price">
                                    <h3>{{ 'starting from' | translate }}</h3>
                                    SCR {{ item.rateFrom | number }}
                                    <!-- - SCR {{ item.rateTo }} -->
                                  </div>
                                </a>
                              </div>
                              <div *ngIf="item.productCategoryId === 'EVENT'; else eventWishlistHeart">
                                <span class="eventWishlistHeart" (click)="$event.stopPropagation()">
                                  <a (click)="addToWhishList(item)"
                                    ><i
                                      class="fa fa-heart wishlist"
                                      [style.color]="item.color ? item.color : '#fff'"
                                    ></i
                                  ></a>
                                </span>
                              </div>
                              <ng-template #eventWishlistHeart>
                                <span class="wishlistHeart" (click)="$event.stopPropagation()">
                                  <a (click)="addToWhishList(item)"
                                    ><i
                                      class="fa fa-heart wishlist"
                                      [style.color]="item.color ? item.color : '#fff'"
                                    ></i
                                  ></a>
                                </span>
                              </ng-template>
                            </div>
                            <div>
                              <ng-container *ngFor="let accr of item.accredations">
                                <span class="accBookMarkSpan">
                                  <img
                                    [src]="accr"
                                    class="accBookMarkSpanImg"
                                    [pTooltip]="isSustainableSeychelles(accr) ? sstlText(item, accr) : null"
                                    [escape]="false"
                                    tooltipPosition="bottom"
                                  />
                                </span>
                              </ng-container>
                            </div>
                          </ng-template>
                          <a target="_blank" class="product-item alisting" [href]="'/listingdetails/' + item.productId">
                            <div class="locationTitle">
                              <ng-container *ngFor="let classification of item.classification">
                                <div class="locationName list-comma" *ngIf="classification !== ''">
                                  <span [innerHTML]="classification"></span>
                                </div>
                              </ng-container>
                              <h5>{{ item.productName }}<i class="icon-safe"></i></h5>

                              <div class="locationName" *ngIf="item.island">
                                <i class="icon-location"></i>{{ item.addresses[0].islandArea
                                }}<span *ngIf="item.island && item.addresses[0].islandArea">,&nbsp;</span
                                >{{ item.island }}
                              </div>
                            </div>
                          </a>
                        </p-card>
                      </div>
                    </ng-container>
                  </div>
                  <div class="row mt-10">
                    <div class="col-md-12 text-center" *ngIf="isViewPlacesMoreRecords">
                      <a class="btn btn-primary btn-lg" (click)="ViewPlacesMoreRecord()"
                        >{{ 'View more' | translate }} <i class="glyphicon glyphicon-plus"></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="p-grid accommodationGrid" *ngIf="i == 2">
                <div class="p-lg-12" style="padding: 15px !important">
                  <div class="p-grid" #productsList>
                    <ng-container *ngFor="let item of thingsToDoData">
                      <div class="p-col-12 p-md-6 p-lg-3">
                        <p-card>
                          <ng-template pTemplate="header">
                            <div>
                              <a
                                target="_blank"
                                class="product-item alisting"
                                [href]="'/listingdetails/' + item.productId"
                              >
                                <img class="CategoriesImages" [src]="item.productImage"
                              /></a>
                              <div *ngIf="item.rateFrom" class="accomodationPrice">
                                <a
                                  target="_blank"
                                  class="product-item alisting"
                                  [href]="'/listingdetails/' + item.productId"
                                >
                                  <div class="price">
                                    <h3>{{ 'starting from' | translate }}</h3>
                                    SCR {{ item.rateFrom | number }}
                                    <!-- - SCR {{ item.rateTo }} -->
                                  </div>
                                </a>
                              </div>
                              <div *ngIf="item.productCategoryId === 'EVENT'; else eventWishlistHeart">
                                <span class="eventWishlistHeart" (click)="$event.stopPropagation()">
                                  <a (click)="addToWhishList(item)"
                                    ><i
                                      class="fa fa-heart wishlist"
                                      [style.color]="item.color ? item.color : '#fff'"
                                    ></i
                                  ></a>
                                </span>
                              </div>
                              <ng-template #eventWishlistHeart>
                                <span class="wishlistHeart" (click)="$event.stopPropagation()">
                                  <a (click)="addToWhishList(item)"
                                    ><i
                                      class="fa fa-heart wishlist"
                                      [style.color]="item.color ? item.color : '#fff'"
                                    ></i
                                  ></a>
                                </span>
                              </ng-template>
                            </div>
                            <div>
                              <ng-container *ngFor="let accr of item.accredations">
                                <span class="accBookMarkSpan">
                                  <img
                                    [src]="accr"
                                    class="accBookMarkSpanImg"
                                    [pTooltip]="isSustainableSeychelles(accr) ? sstlText(item, accr) : null"
                                    [escape]="false"
                                    tooltipPosition="bottom"
                                  />
                                </span>
                              </ng-container>
                            </div>
                          </ng-template>
                          <a target="_blank" class="product-item alisting" [href]="'/listingdetails/' + item.productId">
                            <div class="locationTitle">
                              <ng-container *ngFor="let classification of item.classification">
                                <div class="locationName list-comma" *ngIf="classification !== ''">
                                  <span [innerHTML]="classification"></span>
                                </div>
                              </ng-container>
                              <h5>{{ item.productName }}<i class="icon-safe"></i></h5>

                              <div class="locationName" *ngIf="item.island">
                                <i class="icon-location"></i>{{ item.addresses[0].islandArea
                                }}<span *ngIf="item.island && item.addresses[0].islandArea">,&nbsp;</span
                                >{{ item.island }}
                              </div>
                            </div>
                          </a>
                        </p-card>
                      </div>
                    </ng-container>
                  </div>
                  <div class="row mt-10">
                    <div class="col-md-12 text-center" *ngIf="isViewThingsMoreRecords">
                      <a class="btn btn-primary btn-lg" (click)="ViewThingsMoreRecord()"
                        >{{ 'View more' | translate }} <i class="glyphicon glyphicon-plus"></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
